/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StatAggregateDataPoint } from './StatAggregateDataPoint';
import {
    StatAggregateDataPointFromJSON,
    StatAggregateDataPointFromJSONTyped,
    StatAggregateDataPointToJSON,
    StatAggregateDataPointToJSONTyped,
} from './StatAggregateDataPoint';

/**
 * 
 * @export
 * @interface StatsGetResponse
 */
export interface StatsGetResponse {
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    created_persons?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    deleted_persons?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    active_persons?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {number}
     * @memberof StatsGetResponse
     */
    active_persons_total?: number;
    /**
     * 
     * @type {number}
     * @memberof StatsGetResponse
     */
    persons_failed_authentication_total?: number;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    returning_persons?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {number}
     * @memberof StatsGetResponse
     */
    returning_persons_total?: number;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    authentications?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    successful_authentications?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    successful_mfa?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    failed_authentications?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {{ [key: string]: Array<StatAggregateDataPoint>; }}
     * @memberof StatsGetResponse
     */
    failed_authentications_by_reason?: { [key: string]: Array<StatAggregateDataPoint>; };
    /**
     * 
     * @type {{ [key: string]: Array<StatAggregateDataPoint>; }}
     * @memberof StatsGetResponse
     */
    failed_authentications_by_handle_type?: { [key: string]: Array<StatAggregateDataPoint>; };
    /**
     * 
     * @type {{ [key: string]: Array<StatAggregateDataPoint>; }}
     * @memberof StatsGetResponse
     */
    failed_authentications_by_auth_method?: { [key: string]: Array<StatAggregateDataPoint>; };
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    failed_mfa?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {number}
     * @memberof StatsGetResponse
     */
    person_retention?: number;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    gate_server_starts?: Array<StatAggregateDataPoint>;
    /**
     * 
     * @type {Array<StatAggregateDataPoint>}
     * @memberof StatsGetResponse
     */
    gate_requests_handled?: Array<StatAggregateDataPoint>;
}

/**
 * Check if a given object implements the StatsGetResponse interface.
 */
export function instanceOfStatsGetResponse(value: object): value is StatsGetResponse {
    return true;
}

export function StatsGetResponseFromJSON(json: any): StatsGetResponse {
    return StatsGetResponseFromJSONTyped(json, false);
}

export function StatsGetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatsGetResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'created_persons': json['created_persons'] == null ? undefined : ((json['created_persons'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'deleted_persons': json['deleted_persons'] == null ? undefined : ((json['deleted_persons'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'active_persons': json['active_persons'] == null ? undefined : ((json['active_persons'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'active_persons_total': json['active_persons_total'] == null ? undefined : json['active_persons_total'],
        'persons_failed_authentication_total': json['persons_failed_authentication_total'] == null ? undefined : json['persons_failed_authentication_total'],
        'returning_persons': json['returning_persons'] == null ? undefined : ((json['returning_persons'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'returning_persons_total': json['returning_persons_total'] == null ? undefined : json['returning_persons_total'],
        'authentications': json['authentications'] == null ? undefined : ((json['authentications'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'successful_authentications': json['successful_authentications'] == null ? undefined : ((json['successful_authentications'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'successful_mfa': json['successful_mfa'] == null ? undefined : ((json['successful_mfa'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'failed_authentications': json['failed_authentications'] == null ? undefined : ((json['failed_authentications'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'failed_authentications_by_reason': json['failed_authentications_by_reason'] == null ? undefined : json['failed_authentications_by_reason'],
        'failed_authentications_by_handle_type': json['failed_authentications_by_handle_type'] == null ? undefined : json['failed_authentications_by_handle_type'],
        'failed_authentications_by_auth_method': json['failed_authentications_by_auth_method'] == null ? undefined : json['failed_authentications_by_auth_method'],
        'failed_mfa': json['failed_mfa'] == null ? undefined : ((json['failed_mfa'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'person_retention': json['person_retention'] == null ? undefined : json['person_retention'],
        'gate_server_starts': json['gate_server_starts'] == null ? undefined : ((json['gate_server_starts'] as Array<any>).map(StatAggregateDataPointFromJSON)),
        'gate_requests_handled': json['gate_requests_handled'] == null ? undefined : ((json['gate_requests_handled'] as Array<any>).map(StatAggregateDataPointFromJSON)),
    };
}

export function StatsGetResponseToJSON(json: any): StatsGetResponse {
    return StatsGetResponseToJSONTyped(json, false);
}

export function StatsGetResponseToJSONTyped(value?: StatsGetResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'created_persons': value['created_persons'] == null ? undefined : ((value['created_persons'] as Array<any>).map(StatAggregateDataPointToJSON)),
        'deleted_persons': value['deleted_persons'] == null ? undefined : ((value['deleted_persons'] as Array<any>).map(StatAggregateDataPointToJSON)),
        'active_persons': value['active_persons'] == null ? undefined : ((value['active_persons'] as Array<any>).map(StatAggregateDataPointToJSON)),
        'active_persons_total': value['active_persons_total'],
        'persons_failed_authentication_total': value['persons_failed_authentication_total'],
        'returning_persons': value['returning_persons'] == null ? undefined : ((value['returning_persons'] as Array<any>).map(StatAggregateDataPointToJSON)),
        'returning_persons_total': value['returning_persons_total'],
        'authentications': value['authentications'] == null ? undefined : ((value['authentications'] as Array<any>).map(StatAggregateDataPointToJSON)),
        'successful_authentications': value['successful_authentications'] == null ? undefined : ((value['successful_authentications'] as Array<any>).map(StatAggregateDataPointToJSON)),
        'successful_mfa': value['successful_mfa'] == null ? undefined : ((value['successful_mfa'] as Array<any>).map(StatAggregateDataPointToJSON)),
        'failed_authentications': value['failed_authentications'] == null ? undefined : ((value['failed_authentications'] as Array<any>).map(StatAggregateDataPointToJSON)),
        'failed_authentications_by_reason': value['failed_authentications_by_reason'],
        'failed_authentications_by_handle_type': value['failed_authentications_by_handle_type'],
        'failed_authentications_by_auth_method': value['failed_authentications_by_auth_method'],
        'failed_mfa': value['failed_mfa'] == null ? undefined : ((value['failed_mfa'] as Array<any>).map(StatAggregateDataPointToJSON)),
        'person_retention': value['person_retention'],
        'gate_server_starts': value['gate_server_starts'] == null ? undefined : ((value['gate_server_starts'] as Array<any>).map(StatAggregateDataPointToJSON)),
        'gate_requests_handled': value['gate_requests_handled'] == null ? undefined : ((value['gate_requests_handled'] as Array<any>).map(StatAggregateDataPointToJSON)),
    };
}

